import axios from 'axios';

import { sortHais, isValidTehai, isValidFuros } from './haiUtils';

const apiClient = axios.create({
  // 環境変数名を修正し、ローカル開発用のフォールバックを設定
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
});

const parseTehai = (tehai) => {
  const validTehaiMessage = isValidTehai(tehai);
  if (validTehaiMessage !== null) {
    throw new Error(validTehaiMessage);
  }

  return sortHais(tehai).join(',');
};

const parseFuros = (furos) => {
  const validFurosMessage = isValidFuros(furos);
  if (validFurosMessage !== null) {
    throw new Error(validFurosMessage);
  }

  return furos.reduce((result, haiIdList, index) => {
    if (haiIdList.length > 0) {
      result.push(sortHais(haiIdList).join(','));
    }
    return result;
  }, []);
};

/**
 * バックエンドから打牌推論の結果を取得します。
 * @param {number[]} tehai - 手牌のID配列
 * @param {Array<number[]>} furos - 副露のID配列の配列 (例: [[1,2,3], [11,11,11]])
 * @param {string} [modelVersion] - 使用する推論モデルのバージョン (例: 'v4', 'v5')
 * @returns {Promise<object|null>} 推論結果のデータ。手牌がない場合はnullを返す。
 */
export const fetchPrediction = async (tehai, furos, modelVersion) => {
  const params = new URLSearchParams();
  params.append('tehai', parseTehai(tehai));
  for (const [i, furo] of parseFuros(furos).entries()) {
    params.append(`furo${i + 1}`, furo);
  }
  // modelVersionが指定されていれば、クエリパラメータに追加
  if (modelVersion) {
    params.append('model_version', modelVersion);
  }
  const response = await apiClient.get('/predict/dahai', { params });
  return response.data;
};

export const fetchAgarihais = async (tehai, furos) => {
  const params = new URLSearchParams();
  params.append('tehai', parseTehai(tehai));
  for (const [i, furo] of parseFuros(furos).entries()) {
    params.append(`furo${i + 1}`, furo);
  }
  const response = await apiClient.get('/calculate/agarihai', { params });
  return response.data;
};

/**
 * バックエンドに画像ファイルを送信し、牌の検出結果を取得します。
 * @param {File} file - ユーザーが選択した画像ファイル
 * @returns {Promise<object>} 検出結果のデータ
 */
export const fetchDetection = async (file) => {
  const formData = new FormData();
  formData.append('file', file); // バックエンドの引数名 'file' に合わせる

  const response = await apiClient.post('/predict/recognition', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};